import { render, staticRenderFns } from "./FeedbackExams.vue?vue&type=template&id=1921f179&"
import script from "./FeedbackExams.vue?vue&type=script&lang=js&"
export * from "./FeedbackExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports